import React, { createContext, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";

export const ReportsContext = createContext();
export const ACTIONS = {
  SET_JSON_DETALLE_ACCIONES: "SET_JSON_DETALLE_ACCIONES",
  SET_RESPONSE_DETALLE_ACCIONES:"SET_RESPONSE_DETALLE_ACCIONES",
  SET_ERROR:"SET_ERROR",

};

const initialState = {
  jsonDetallenAcciones: null,
  responseDetalleAcciones: null,
  errorFetch: null,

};


const ReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_JSON_DETALLE_ACCIONES: {
      return {
        ...state,
        jsonDetallenAcciones: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_DETALLE_ACCIONES: {
        return {
          ...state,
          responseDetalleAcciones: action.payload,
        };
      }
    case ACTIONS.SET_ERROR: {
      return {
          ...state,
          errorFetch: action.payload
      };
    }
    default: {
      return state;
    }
  }
};
const ReportsContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(ReportsReducer, initialState);
  

  React.useEffect(() => {
    if(state.jsonDetallenAcciones){
      LiferayService.getAccionesDetalle(properties.base_url_api, state.jsonDetallenAcciones)
      .then((response) => {
            dispatch({
                payload: response,
                type: ACTIONS.SET_RESPONSE_DETALLE_ACCIONES,
            });
            dispatch({
                payload: null,
                type: ACTIONS.SET_ERROR,
            });
      })
      .catch((error) => {
            dispatch({
                payload: error,
                type: ACTIONS.SET_ERROR,
            });
      })
    }
  }, [state.jsonDetallenAcciones])


  return (
    <ReportsContext.Provider value={[state, dispatch]}>
      {children}
    </ReportsContext.Provider>
  );
};
export default ReportsContextProvider;